"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SimpleDate = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const SimpleDate = ({
  date = ''
}) => {
  return /*#__PURE__*/_react.default.createElement("span", null, new Date(date).toLocaleDateString('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric'
  }));
};

exports.SimpleDate = SimpleDate;